import React, { useState } from 'react';
import {
  ChevronRight as ChevronRightIcon,
  KeyboardArrowDown as ChevronDownIcon,
} from '@material-ui/icons';
import { numberFormat } from 'utils/mathCommon';
import StakeDetail from '../staking/StakeDetail';
import { useSelector } from 'react-redux';
import { Box, Flex } from '@chakra-ui/react';
import { Button, Tooltip } from 'antd';
import { connectWeb3Modal } from 'Connections/web3Modal';
import styled from 'styled-components';
import { UNLIMITED_WANA } from '__mocks__/PackageData';
import AddIcon from '@material-ui/icons/Add';
// import HelpIcon from '@material-ui/icons/Add';

const StyledPackages = styled.div`
  border-bottom: 1px solid var(--background-color);
  &:last-child {
    border-bottom: none;
  }
`;
const StyledPackage = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  flex-wrap: wrap;
`;

const StyledRateDisplay = styled.div`
  align-items: center;
  padding: 7px 5px 7px 10px;
  font-size: 18px;
  width: fit-content;
  background: linear-gradient(to right, #10c6ac, #10c6ac 90%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  font-size: 20px;
`;

const StyledOptionDuration = styled.div`
  padding: 7px 22px;
  text-align: center;
  border-radius: 5px;
  text-transform: uppercase;
  font-size: 18px;
  cursor: pointer;
  color: ${({ active }) => (active ? '#f2a603' : '#f1f1f1')};
  background: none;
  font-weight: 400;
  background: ${({ active }) =>
    active ? 'linear-gradient(to right, #f2a603 ,#f2a603  100%)' : '#2ea8f1'};
  position: relative;
  z-index: 1;
  &::before {
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    content: '';
    position: absolute;
    top: 1px;
    right: 1px;
    z-index: -1;
    border-radius: 5px;
    background: var(--card-color);
  }
  @media screen and (max-width: 375px) {
    padding: 7px 19px;
  }
  @media screen and (max-width: 350px) {
    padding: 7px 16px;
  }
`;
const StyledRangeAmount = styled.div`
  width: fit-content;
  padding: 7px 13px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
`;

const StyledTypeLock = styled.div`
  width: fit-content;
  border-radius: 6px;
  padding: 7px 15px;
  background: var(--bg-badge);
  color: var(--color-badge);
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
`;
const StyledItemName = styled.div`
  padding: 10px;
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
`;
const StyledItemRate = styled.div`
  padding: 10px;
  flex: 2;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    color: #f1a602;
  }
`;

const StyledGift = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 500;
  span.detail {
    font-size: 16px;
    color: #f2a603;
    vertical-align: middle;
    line-height: 11px
  }
`;

const StyledItemType = styled.div`
  padding: 10px;
  flex: 1;
  @media screen and (max-width: 600px) {
    display: none;
  }
`;

const StyledItemAmount = styled.div`
  padding: 10px;
  flex: 2;
  white-space: nowrap;
`;
const StyledItemDuration = styled.div`
  padding: 0 10px;
  flex: 4;
  display: grid;
  grid-gap: 10px;
  align-items: center;
  grid-auto-flow: column;
  @media screen and (max-width: 600px) {
    padding: 0;
    width: 100%;
    justify-content: space-between;
  }
`;

const StyledItemAction = styled.div`
  display: flex;
  flex: 1;
  cursor: pointer;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
`;

export default function Package({ item, rootUrlsView, fetchDetailPool, fetchTotalValue }) {
  const { walletAddress } = useSelector((state) => state);
  const [isStaked, setIsStaked] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const defaultOption = item.options.find((option) => option.isDefault);

  const [selectOption, setSelectOption] = useState(
    item.options.find((option) => option.id === defaultOption.id)
  );

  const handleSelectedOption = (optionId) => {
    const foundOption = item.options.find((option) => option.id === optionId);
    setSelectOption(foundOption);
  };

  const handleStake = async () => {
    if (!walletAddress) {
      try {
        setLoading(true);
        await connectWeb3Modal();
        setIsStaked(!isStaked);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
      return;
    }

    setIsStaked(!isStaked);
  };

  const getRangeAmount = () => {
    const minAmount = numberFormat(item.minStake);
    const maxAmount = item.maxStake === UNLIMITED_WANA ? 'Unlimited' : numberFormat(item.maxStake);
    return `${minAmount} - ${maxAmount}  ${item.tokenName}`;
  };

  const titleByGiftDetail = (giftDetail) => {
    switch (giftDetail) {
      case '*': {
        return 'The snapshot will be taken at the end of every month to do lucky draw, from July until December, 2022'
      }
      case '**': {
        return 'The snapshot will be taken at December 31st, 2022'
      }
      case '***': {
        return 'Granted to the Wallet at the end of staking contract'
      }
      default: {
        return ''
      }
    }
  }

  return (
    <StyledPackages>
      <StyledPackage align='center'>
        <StyledItemName>{item.name}</StyledItemName>
        <StyledItemRate>
          <StyledRateDisplay>{selectOption.rate}%</StyledRateDisplay>
          {selectOption.gift && (
            <>
              <AddIcon margin='0 10px' height='12px' />
              <StyledGift>
                {selectOption.gift}
                <Tooltip title={titleByGiftDetail(selectOption.giftDetail)}>
                  (<span className="detail">{selectOption.giftDetail}</span>)
                </Tooltip>
              </StyledGift>
            </>
          )}
        </StyledItemRate>
        <StyledItemDuration>
          {item.options.filter(i => i.display).map((option) => {
            return (
              <StyledOptionDuration
                key={option.id}
                active={option.id === selectOption.id}
                onClick={() => handleSelectedOption(option.id)}
              >
                {option.duration}
                <Box fontWeight='700' fontSize='10px' mt='-5px'>
                  Days
                </Box>
              </StyledOptionDuration>
            );
          })}
        </StyledItemDuration>
        <StyledItemType>
          <StyledTypeLock>Lock</StyledTypeLock>
        </StyledItemType>
        <StyledItemAmount>
          <StyledRangeAmount>{getRangeAmount()}</StyledRangeAmount>
        </StyledItemAmount>
        <StyledItemAction onClick={handleStake}>
          <div>
            {isStaked ? (
              <ChevronDownIcon w='30px' h='30px' />
            ) : (
              <Flex alignItems='center'>
                <div className='wrap-amount-stake-v2'>
                  <Button type='primary' className='btn-stake' size='large' loading={isLoading}>
                    {!walletAddress ? 'Unlock Wallet' : 'Stake Now'}
                  </Button>
                  <ChevronRightIcon w='30px' h='30px' />
                </div>
              </Flex>
            )}
          </div>
        </StyledItemAction>
      </StyledPackage>

      {isStaked && (
        <StakeDetail
          packageItem={item}
          option={selectOption}
          rootUrlsView={rootUrlsView}
          fetchDetailPool={fetchDetailPool}
          fetchTotalValue={fetchTotalValue}
        />
      )}
    </StyledPackages>
  );
}
